<template>
  <div id="app">
    <div
      v-if="$root.ready && overflow"
      class="ready-overflow"
      @click="openWebsite()"
    >
      <button
        class="btn btn-outline-primary text-uppercase"
        @click="openWebsite()"
      >
        Buka Undangan
      </button>
    </div>

    <AGWAudio :file="music.file" :loop="music.loop" :autoplay="music.autoplay" ref="audio" />
    <AGWHero overlay :background="backgrounds" ref="hero" parallax target="#intro" />

    <div class="agw-content" :style="{ 'margin-top' : `${$root.hero.height}px` }">
      <AGWIntro id="intro">
        <AGWMepandes id="mepandes" class="mar-top-60" :mepandes="mepandes" />
      </AGWIntro>
<!-- 
      <div class="pad-y-60">
        <AGWPawiwahan id="pawiwahan" />
      </div> -->

      <AGWCounter id="counter" class="pad-y-60" :background="background" :date="time.start" />
      <!-- <AGWGallery id="gallery" class="pad-y-60" /> -->
      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7889.40700874808!2d115.11563567424506!3d-8.624436875208417!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x801c067ca91b1d34!2sUD.%20EVAN!5e0!3m2!1sen!2sid!4v1607871611018!5m2!1sen!2sid"
        directionUrl="https://www.google.co.id/maps/dir//UD.+EVAN,+Jl.+Pantai+Seseh,+Cemagi,+Kec.+Mengwi,+Kabupaten+Badung,+Bali+80351/@-8.6244369,115.1156357,16z/data=!4m9!4m8!1m0!1m5!1m1!1s0x2dd23837e6a83073:0x801c067ca91b1d34!2m2!1d115.1171819!2d-8.6255456!3e0?hl=en-id"
        :location="location"
        :time="time"
        id="map"
      />
    </div>

    <div class="agw-content bg-dark">
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <div :style="{ height: `${$root.dividerHeight}px` }"></div>

    <section class="footer bg-white pad-y-20 text-dark" ref="footer">
      <div class="font-weight-lighter">
        &copy; {{ $moment().format('YYYY') }}. Made by
        <a href="https://ceremonyku.com">ceremonyku</a>.
      </div>
    </section>

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height" />
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 =
  "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP2_7309d_8ATY4x84v7.jpg?tr=w-700";
const ImageHero2 =
  "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7469_0Ys66fWW7bc.jpg?tr=w-1024";
const ImageHero3 =
  "https://ik.imagekit.io/aryraditya/ceremonyku/mustika-santi/YP1_7877_P9eT8_tado.jpg?tr=w-1024";

import Audio from "@/assets/audio/backsound.mp3";

import AGWHero from "@/components/Hero";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";

import { setInterval } from "timers";

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance,
  },
  data() {
    return {
      title: "Mepandes",
      backgrounds: [],
      bgActive: 0,
      dividerHeight: 0,
      overflow: true,
      wedding: {
      },
      location: "Jl. Pantai Seseh No 777, Br. Keliki, Cemagi, Mengwi, Badung 80352",
      time: {
        start: this.$moment("2020-12-20 11:00"),
        end: "Selesai",
      },
      mepandes: [
        'I Putu Evan Adhi Putra, ST',
        'I Kadek Bagus Acintiawan, SE',
        'Ni Komang Yovita Mirah Pradnyani'
      ],
      music: {
        file: Audio,
        autoplay: true,
        loop: true,
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false,
      },
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    },
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    // if(navigator.serviceWorker) {
    //   navigator.serviceWorker.addEventListener("controllerchange", () => {
    //   if (this.sw.refreshing) return;
    //   // this.sw.refreshing = true;
    //   // window.location.reload();
    // });
    // }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
      this.sw.refreshing = true;
      window.location.reload();
    },
    openWebsite() {
      this.overflow = false;
      document.querySelector("#loading").classList.remove("active");
      if (this.$refs.audio) this.$refs.audio.play();
    }
  },
};
</script>
